import React, { useState, useMemo } from "react";
import { Alert, Button } from "antd";
import { Link } from "umi";

export const colors = {
  info: {
    main: "#264D99",
    light: "#E5EEFF",
    border: "rgba(18, 25, 38, 0.08)",
    borderAlt: "#004EEB",
    link: "#2C6AC4",
  },
  success: {
    main: "#027A48",
    border: "rgba(50, 168, 82, 0.08)",
    borderAlt: "#289445",
  },
  warning: {
    main: "#D38D00",
    border: "rgba(18, 25, 38, 0.08)",
    borderAlt: "#FFBF3F",
  },
  error: {
    main: "#D92D20",
    boder: "rgba(217, 45, 32, 0.08)",
    borderAlt: "#e0564c",
  },
};

const AlertWithBorder = ({ type, message, actionButtons, style }) => {
  const [fontWeight, setFontWeight] = useState(400);

  const palette = useMemo(() => colors[type] ?? colors.info, [type]);

  return (
    <Alert
      banner
      type={type}
      message={<span style={{ color: palette.main }}>{message}</span>}
      style={{
        borderRadius: "4px",
        border: `1px solid ${palette.border}`,
        borderLeft: `4px solid ${palette.borderAlt}`,
        marginBottom: "24px",
        ...style,
      }}
      action={(actionButtons || []).map(({ key, label, href, onClick }) => {
        const button = (
          <Button
            type="link"
            key={key}
            style={{
              fontWeight,
            }}
            onClick={onClick}
            onMouseEnter={() => setFontWeight(700)}
            onMouseLeave={() => setFontWeight(400)}
          >
            <span style={{ color: palette.main }}>{label}</span>
          </Button>
        );

        if (href) {
          return (
            <Link target="_blank" to={href}>
              {button}
            </Link>
          );
        }

        return button;
      })}
    />
  );
};

export default AlertWithBorder;
